<template>
  <div ref="appContent" class="app-content">
    <el-form
        :inline="true"
        :model="queryForm"
        @keyup.enter.native="$refs.table.reload()"
        ref="queryForm"
        class="query-box"
    >
      <el-form-item prop="sellerName" label="销售方：">
        <el-input v-model="queryForm.sellerName" size="mini" clearable type="text"
                  placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item prop="receiptCode" label="发票号：">
        <el-input v-model="queryForm.receiptCode" size="mini" clearable type="text"
                  placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="$refs.table.reload()" size="mini">查询</el-button>
        <el-button @click="showPayDialog" size="mini" type="warning">批量付款</el-button>
      </el-form-item>
    </el-form>
    <SweetTable url="/erp/make/bills" :query-form="queryForm" :selection="true" ref="table"
                :before-table-binding="beforeTableBinding">
      <el-table-column label="订单编号" width="160" prop="orderCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="工厂名称" width="160" prop="factoryName" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品番号" width="160" prop="product.code" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="SKU" width="100" prop="product.skuCode" header-align="center" align="center"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品名" align="center" prop="product.name" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="中文品名" align="center" prop="product.nameZh" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="颜色" prop="product.color" header-align="center" align="center" width="100"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="规格" prop="product.size" header-align="center" align="center" width="100"
                       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="发票号" prop="receiptCode" header-align="center" align="center"></el-table-column>
      <el-table-column label="入库时间" prop="operateDate" header-align="center" align="center"
                       width="160"></el-table-column>
      <el-table-column label="数量" prop="count" header-align="center" align="center"></el-table-column>
      <el-table-column label="开票单价" prop="price" header-align="center" align="center"></el-table-column>
      <el-table-column label="总金额" prop="totalAmount" header-align="center" align="center"></el-table-column>
      <el-table-column label="已付款" prop="price" header-align="center" align="center"></el-table-column>
      <el-table-column label="未付款" prop="price" header-align="center" align="center"></el-table-column>
    </SweetTable>
    <PayDialog ref="PayDialog"></PayDialog>
  </div>
</template>

<script>
import BigNumber from 'bignumber.js'
import PayDialog from '@/views/modules/erp/pay/pay-dialog.vue'

/**
 * 加工应付列表
 */
export default {
  name: 'MakeBills',
  components: { PayDialog },
  data () {
    return {
      queryForm: {},
      dataList: []
    }
  },
  activated () {
    this.$refs.table.reload()
  },
  methods: {
    totalAmountChanged (e) {
      //剩余金额
      let surplus = new BigNumber(e)
      if (surplus.isNaN() || !this.dataList || this.dataList.length === 0) {
        return
      }
      for (let i = 0; i < this.dataList.length; i++) {
        let row = this.dataList[i]
        if (surplus.isLessThanOrEqualTo(0)) {
          row.amount = 0
          break
        }
        if (surplus.isGreaterThanOrEqualTo(row.totalAmount)) {
          if (i === this.dataList.length - 1) {
            row.amount = surplus.toFixed(2)
          } else {
            row.amount = row.totalAmount
            surplus = surplus.minus(row.totalAmount)
          }
        } else {
          row.amount = surplus.abs().toFixed(2)
          surplus = new BigNumber(0)
        }
      }
    },
    showPayDialog () {
      this.$refs.PayDialog.init()
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.totalAmount = new BigNumber(row.price).multipliedBy(row.count).toFixed(2)
        console.log(row.totalAmount)
      })
    }
  }
}
</script>

<style scoped>

</style>
